module.exports = {
  background: [1, 1, 1, 1],
  meshColor: [0, 0.6, 1, 1], // default face color or line color
  lightColor: [1, 1, 1, 1], // note: for now there is a single preset light, not an entity
  lightDirection: [0.2, 0.2, 1],
  lightPosition: [100, 200, 100],
  ambientLightAmount: 0.3,
  diffuseLightAmount: 0.89,
  specularLightAmount: 0.16,
  materialShininess: 8.0
}
